<template>
  <div v-if="reRenderImages">
    <out-of-stock v-if="outOfStock">
    </out-of-stock>
    <agile
      :rtl="false"
      :dots="dots"
      :navButtons="false"
    >
      <div
        class="slide"
        v-for="(images, index) in imageArray.filter(img => img !== null)"
        :key="index"
        @click="modalopen(index)"
								:data-test="'imageSliderImageArray1'+index"
								:id="'imageSliderImageArray1'+index"
      >
        <img
          :src="images"
          alt="Slider images"
										:data-test="'imageSliderImg1'+index"
										:id="'imageSliderImg1'+index"
        >
      </div>
    </agile>
    <div
      class="nice-modal"
      :id="'lightBoxMob-product-image-slider-'+index"
    >
      <span
        class="reviewmodalclose"
        @click.prevent="closemodal"
								data-test="imageSliderCloseSpan"
								id="imageSliderCloseSpan"
      >
        <i class="fas fa-times"
											data-test="imageSliderCloseIcon" id="imageSliderCloseIcon"></i>
      </span>
      <div class="image-wrapper">
        <out-of-stock v-if="outOfStock">
        </out-of-stock>
        <agile
          :rtl="false"
          :dots="dots"
          :navButtons="false"
        >
          <div
            class="slide"
            v-for="(images, index) in imageArray.filter(img => img !== null)"
            :key="index"
												:data-test="'imageSliderImageArray2'+index"
												:id="'imageSliderImageArray2'+index"
          >
            <img
              :src="images"
              alt="Slider Images"
														:data-test="'imageSliderImg2'+index"
														:id="'imageSliderImg2'+index"
            >
          </div>
        </agile>
      </div>
    </div>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile'
import OutOfStock from '@/components/widgets/outofstock/OutOfStock'
import { fullScreenImageModal } from '../../../../../../commonJs/FullScreenImageModal'

export default {
	name: 'mobile-image-slider',
	data () {
		return {
			selectedVendorIndex: 0,
			index: 0,
			reRenderImages: true
		}
	},
	components: {
		agile: VueAgile,
		OutOfStock
	},
	props: {
		imageArray: Array,
		dots: {
			type: Boolean,
			default: false
		},
		outOfStock: {
			type: Boolean,
			default: false
		},
		indexKey: {
			type: String,
			default: ''
		},
		initialSlide: {
			type: Number,
			default: 0
		}
	},
	methods: {
		closemodal (e) {
			fullScreenImageModal.closeModal(e, '-product-image-slider-', this.index)

			// document.querySelector('.reviewmodalclose').closest('.nice-modal').classList.remove('open');
		},
		modalopen (key) {
			this.index = key
			fullScreenImageModal.modalOpen(screen.width, '-product-image-slider-', this.index)
			// document.querySelector('.reviewmodalclose').closest('.nice-modal').classList.add('open');
		}
	},
	watch: {
		imageArray () {
			this.reRenderImages = false
			setTimeout(() => {
				this.reRenderImages = true
			}, 50)
		}
	}
}
</script>

<style scoped>
</style>
